module.exports = __webpack_public_path__ + "media/bootstrap-icons/cpu-fill-6ab68e8e.svg";